import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  BUS_MAINTENANCE_STAY_PATH,
  NEW_BUS_MAINTENANCE_STAY_PATH,
} from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { BUS_MAINTENANCE_STAY_COLUMNS } from '../../../../config/columns';
import {
  clearBussesMaintenanceStay,
  getBussesMaintenanceStay,
} from '../../../../actions/mechanical-maintenance/BusMaintenanceStay';

export const BussesMaintenanceStay = ({
  breadcrumbs,
  bussesMaintenanceStay,
  loading,
  dispatchGetBussesMaintenanceStay,
  dispatchClearBussesMaintenanceStay,
}) => {
  useLayoutEffect(() => () => dispatchClearBussesMaintenanceStay(), []);

  const data = bussesMaintenanceStay.get('content') || [];
  const pages = bussesMaintenanceStay.get('totalPages') || null;
  const defaultPageSize =
    bussesMaintenanceStay.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Estancias de Mantenimiento por Bus"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_BUS_MAINTENANCE_STAY_PATH}
      tableStructure={{
        columns: BUS_MAINTENANCE_STAY_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetBussesMaintenanceStay,
        modelPath: BUS_MAINTENANCE_STAY_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetBussesMaintenanceStay: getBussesMaintenanceStay,
  dispatchClearBussesMaintenanceStay: clearBussesMaintenanceStay,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Estancias de Mantenimiento por Bus',
      href: BUS_MAINTENANCE_STAY_PATH,
    },
  ],
  bussesMaintenanceStay: MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
    'all',
    'content',
  ]),
  loading: MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
    'all',
    'loading',
  ]),
});

BussesMaintenanceStay.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  bussesMaintenanceStay: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetBussesMaintenanceStay: PropTypes.func.isRequired,
  dispatchClearBussesMaintenanceStay: PropTypes.func.isRequired,
};

BussesMaintenanceStay.defaultProps = {
  bussesMaintenanceStay: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BussesMaintenanceStay);
